module.exports = __webpack_public_path__ + "img/banner-03.4911d79d.png";